import axios from '@_system/axios/axios.js'
export default {
	path: '/invoicecustomerorder',
	list(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	copyBycode(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/copyBycode', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/admin/invoice.invoicecustomerorder', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	},
	electronicInvoice(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/electronicInvoice', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listTrades(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/listTrades/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	sendemail(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/sendemail/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	savebatch(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path+'/savebatch', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},	
	static (data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/static', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	gettotalerror (data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/gettotalerror', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	
	clearerror (data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/clearerror', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	reversal (id,data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/reversal/'+id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	repair (id,data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/repair/'+id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
